<template>
  <div>
    <div class="title-box">
      <div class="title1">服务协议</div>
      <div class="title2">游选代售服务协议详情</div>
<!--      <el-image class="img" :src="require('@/assets/image/TradeTip/serviceAgreement.png')"></el-image>-->
    </div>
    <div class="ql-container ql-snow">
      <p class="tradeTipContent ql-editor" v-html="pageInfo"></p>
    </div>
  </div>
</template>

<script>
import {apiPageInfo} from "@/request/API";

export default {
  name: "serviceAgreement",
  data() {
    return {
      pageInfo: ''
    }
  },
  mounted() {
    this.getPageInfo()
  },
  methods: {
    getPageInfo() {
      apiPageInfo({
        id: 63
      }).then(res => {
        this.pageInfo = res.data.content
      })
    }
  },
}
</script>

<style scoped lang="less">
.title-box {
  width: auto;
  min-height: 96px;
  background: linear-gradient(93deg, var(--bg-tag, #F0EDE8) 0%, rgba(255, 255, 255, 0) 100%);
  margin: 32px 40px 0;
  padding: 20px 28px;
  border: 1px solid var(--border-soft, #E8E4DE);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  box-sizing: border-box;

  &::before {
    content: '';
    width: 5px;
    height: 32px;
    background: var(--bg-dark, #1A1D24);
    transform: skewX(-12deg);
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -16px;
  }

  .title1 {
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: var(--text-main, #111827);
    line-height: 30px;
  }

  .title2 {
    margin-top: 6px;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 20px;
  }

  .img {
    width: 112px;
    position: absolute;
    left: 35px;
  }

}

.ql-container.ql-snow {
  border: none;
  padding: 28px 48px 72px;
  margin-top: 0;
  font-size: 15px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 400;
  color: var(--text-secondary, #5A5F6B);
  line-height: 1.9;
}

.tradeTipContent {
  padding: 0 !important;
  color: var(--text-secondary, #5A5F6B);
  word-break: break-word;
}

.tradeTipContent /deep/ h1,
.tradeTipContent /deep/ h2,
.tradeTipContent /deep/ h3 {
  margin: 0 0 16px;
  color: var(--text-main, #111827);
  font-weight: 600;
  line-height: 1.45;
}

.tradeTipContent /deep/ h2 {
  font-size: 22px;
}

.tradeTipContent /deep/ h3 {
  margin-top: 28px;
  font-size: 18px;
}

.tradeTipContent /deep/ p {
  margin: 0 0 14px;
}
</style>
